"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
const core_1 = require("@angular/core");
const platform_browser_1 = require("@angular/platform-browser");
const forms_1 = require("@angular/forms");
const http_1 = require("@angular/http");
const alarmConfig_1 = require("./../../alarm/src/config/alarmConfig");
const alarm_1 = require("./../../alarm/src/alarm");
const alarmUi_routing_1 = require("./alarmUi.routing");
const historical_alarm_list_component_1 = require("./alarmList/historical-alarm-list.component");
const inaxConfiguration_1 = require("./../../common/src/inaxConfiguration");
const translate_module_1 = require("./../../translate/src/translate.module");
const commonUi_module_1 = require("./../../commonUi/src/commonUi.module");
const resource_service_1 = require("./resources/resource.service");
const pending_alarm_list_component_1 = require("./alarmList/pending-alarm-list.component");
const alarm_line_component_1 = require("./alarmLine/alarm-line.component");
let AlarmUiModule = class AlarmUiModule {
    //Resource manager adds the translations to the translationservice
    constructor(_resourceManager) {
        this._resourceManager = _resourceManager;
    }
};
AlarmUiModule = __decorate([
    core_1.NgModule({
        imports: [
            //Modules
            platform_browser_1.BrowserModule,
            forms_1.FormsModule,
            http_1.HttpModule,
            translate_module_1.TranslateModule,
            commonUi_module_1.CommonUiModule,
            alarmUi_routing_1.ALARM_ROUTES
        ],
        exports: [
            alarm_line_component_1.AlarmLineComponent
        ],
        declarations: [
            //Components
            historical_alarm_list_component_1.HistoricalAlarmListComponent,
            pending_alarm_list_component_1.PendingAlarmListComponent,
            alarm_line_component_1.AlarmLineComponent
        ],
        providers: [
            //Services
            inaxConfiguration_1.InaxConfiguration,
            alarmConfig_1.InaxAlarmConfig,
            alarm_1.InaxAlarmService,
            resource_service_1.AlarmUiResourceManager
        ],
        bootstrap: []
    }),
    __metadata("design:paramtypes", [resource_service_1.AlarmUiResourceManager])
], AlarmUiModule);
exports.AlarmUiModule = AlarmUiModule;
